/**
 * FT-019 async PDF signing flow.
 *
 * apiClient: axios instance for rentalman-api calls. Токен передаётся явно
 *   per request; глобальный интерсептор его тоже подставил бы, но только для
 *   нашего origin (utils/apiOrigin.js).
 * bareAxios: axios without interceptors (for direct S3 PUT; the presigned URL
 *   is already signed, no JWT needed and no JWT must leak to S3). Начиная с
 *   utils/apiOrigin.js глобальный инстанс на S3 заголовков тоже не ставит —
 *   отдельный инстанс остаётся как второй рубеж и как явное намерение.
 * authToken: JWT in "Bearer <jwt>" form. Pass from this.$store.getters.getAuthToken.
 */
export async function uploadAndSignPdf({
  apiClient,
  bareAxios,
  bookingId,
  templateId,
  pdfBlob,
  authToken,
  pollIntervalMs = 2000,
  pollTimeoutMs = 60000,
}) {
  const authHeaders = authToken ? { Authorization: authToken } : {};

  const presign = (await apiClient.post('/api/v1/generated_documents/presign', {
    booking_id: bookingId,
    template_id: templateId,
    content_type: 'application/pdf',
  }, { headers: authHeaders })).data;

  await bareAxios.put(presign.upload_url, pdfBlob, {
    headers: { 'Content-Type': 'application/pdf' },
    transformRequest: [(data) => data],
  });

  await apiClient.post(
    `/api/v1/generated_documents/${presign.document_id}/finalize`,
    {},
    { headers: authHeaders }
  );

  return pollDocumentReady({
    apiClient,
    documentId: presign.document_id,
    intervalMs: pollIntervalMs,
    timeoutMs: pollTimeoutMs,
    authHeaders,
  });
}

async function pollDocumentReady({ apiClient, documentId, intervalMs, timeoutMs, authHeaders }) {
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    const { data } = await apiClient.get(
      `/api/v1/generated_documents/${documentId}`,
      { headers: authHeaders }
    );
    if (data.status === 'ready') return data;
    if (data.status === 'failed') {
      throw new Error(data.failure_reason || 'PDF signing failed');
    }
    await sleep(intervalMs);
  }
  throw new Error('PDF signing timeout — document may still become ready; refresh the list in a minute.');
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
